import DoublesFX, { DOUBLES_VALUES } from "./DoublesFX";
import SixSevenFX, { SIX_SEVEN_VALUE } from "./SixSevenFX";
import SixNineFX, { SIX_NINE_VALUE } from "./SixNineFX";

/**
 * phase2Specials — Registry mapping a called number to a Phase 2
 * signature effect module.
 *
 * Every module renders as a LAYER on top of the standard ball reveal
 * — the ball still appears, spins, opens, and reveals its sacred
 * number normally. Only the visuals/audio around the reveal are
 * augmented. This preserves the golden rule that the revealed number
 * never changes after appearing.
 *
 * Registry shape per entry:
 *   {
 *     key:        stable string id (matches settings toggle key)
 *     label:      human-readable title for settings + previews
 *     tagline:    optional single-line description
 *     Component:  React component (rendered by BingoBall on reveal)
 *     previewValue: () => number — sample number for the Preview button
 *   }
 */

const DOUBLES_ENTRY = {
  key: "doubles",
  label: "Doubles",
  tagline: "11 · 22 · 33 · 44 · 55 · 66 · 77 · 88",
  Component: DoublesFX,
  previewValue: () => {
    const arr = Array.from(DOUBLES_VALUES);
    return arr[Math.floor(Math.random() * arr.length)];
  },
};

const SIX_SEVEN_ENTRY = {
  key: "sixSeven",
  label: "Six Seven",
  tagline: "67 · signature two-beat vocal moment",
  Component: SixSevenFX,
  previewValue: () => SIX_SEVEN_VALUE,
};

const SHY_BALL_ENTRY = {
  key: "shyBall",
  label: "Shy Ball",
  tagline: "69 · either way up · demure rose reveal",
  Component: SixNineFX,
  previewValue: () => SIX_NINE_VALUE,
};

/**
 * getPhase2Special(value)
 *   Returns the registry entry for a value, or null if none applies.
 *   When multiple modules could match a value in future phases, the
 *   FIRST match wins in registration order.
 */
export function getPhase2Special(value) {
  if (value === null || value === undefined) return null;
  const n = Number(value);
  if (n === SIX_SEVEN_VALUE) return SIX_SEVEN_ENTRY;
  if (n === SIX_NINE_VALUE) return SHY_BALL_ENTRY;
  if (DOUBLES_VALUES.has(n)) return DOUBLES_ENTRY;
  return null;
}

/**
 * PHASE2_MODULES — ordered list for settings UI + docs.
 * Extend this as we implement Shy Ball, Bingo Check, etc.
 */
export const PHASE2_MODULES = [DOUBLES_ENTRY, SIX_SEVEN_ENTRY, SHY_BALL_ENTRY];
